import React, { useEffect, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import IframePageTemplate from 'Components/IframePageTemplate/IframePageTemplate'
import {
  getTrackingRestrictedCompanyIds,
  ROUTES,
  trackingIframeUrlsByCompany,
} from 'Utils/constants'

// IDs de compañías que tienen restricción de tracking
const TRACKING_RESTRICTED_COMPANY_IDS = getTrackingRestrictedCompanyIds()

export default function OrderTracking() {
  const history = useHistory()
  const companyId = useSelector(state => state.company.CompanyId)

  // Verificar si la compañía actual tiene acceso al tracking
  const hasTrackingAccess = useMemo(
    () => !TRACKING_RESTRICTED_COMPANY_IDS.includes(companyId),
    [companyId]
  )

  const baseUrlTracking = trackingIframeUrlsByCompany[companyId]

  const orderUrlTracking = `${baseUrlTracking}/orders/`

  useEffect(() => {
    if (!baseUrlTracking || !hasTrackingAccess) {
      history.replace(ROUTES.home)
    }
  }, [history, hasTrackingAccess, baseUrlTracking])

  return <IframePageTemplate loading={false} iframeUrl={orderUrlTracking} />
}
